import { Helmet } from "react-helmet-async";
import { Layout } from "../../components/layout";
import {
  MyButton,
  CustomModal,
  Dropdown,
  Input,
  LoadingSpinner,
  Pagination,
  EmptyTable,
} from "../../components";
import { Link } from "react-router-dom";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian_fa from "react-date-object/locales/persian_fa";
import persian from "react-date-object/calendars/persian";
import { FaArrowRightLong } from "react-icons/fa6";
import { BsList, BsThreeDotsVertical } from "react-icons/bs";
import {
  Menu,
  MenuItem,
  Button,
  Tooltip,
  Select,
  IconButton,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { DealsModelController } from "../../controllers";
import { Cancel } from "../../../assets";
import { IoAddSharp } from "react-icons/io5";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { FaAngleDown } from "react-icons/fa";
class DealsModel extends DealsModelController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getDealsModels();
  }
  render() {
    const {
      dealsModelsList,
      loading,
      subject,
      openConfirmModal,
      errorsList,
      page,
      count,
      rowsCountList,
      selectedItem,
      openEditModal,
      openAddModal,
    } = this.state;
    return (
      <>
        <Layout title="مدل معامله">
          <Helmet>
            <title> مدل معامله | سامانه مشتریان</title>
          </Helmet>
          <div className="users-list">
            {loading ? (
              <LoadingSpinner />
            ) : (
              <>
                <>
                  <div className="users-list-headline mt-3">
                    <div className="">
                      <BsList color="#003366" className="ms-2" />{" "}
                      <span className="title">مدل معامله</span>
                    </div>
                    <div className="btn-group">
                      <MyButton
                        myStyle="add"
                        icon={<IoAddSharp className="ms-2" />}
                        title="افزودن"
                        onClick={() =>
                          this.setState({ openAddModal: !openAddModal })
                        }
                      />
                    </div>
                  </div>
                  <div className="users-list-container">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>ردیف</TableCell>
                          <TableCell>موضوع </TableCell>
                          <TableCell>تعداد معاملات</TableCell>
                          <TableCell>عملیات</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {!dealsModelsList?.list?.length && <EmptyTable />}
                        {dealsModelsList?.list?.map(
                          (item: any, index: number) => {
                            return (
                              <>
                                <TableRow
                                  key={index}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell component="th" scope="row">
                                    {index + 1}
                                  </TableCell>
                                  <TableCell>{item?.subject || "--"}</TableCell>
                                  <TableCell>{item?.total_deals}</TableCell>
                                  <TableCell>
                                    <PopupState
                                      variant="popover"
                                      popupId="demo-popup-menu"
                                    >
                                      {(popupState: any) => (
                                        <>
                                        <IconButton
                                          sx={{
                                            color: "#0c1a58",
                                            padding: "4px"
                                          }}
                                          {...bindTrigger(popupState)}
                                        >
                                          <BsThreeDotsVertical />
                                        </IconButton>
                                          {/* <Button
                                            sx={{
                                              background: "#D4AF37",
                                              ":hover": {
                                                bgcolor: "#D4AF37",
                                              },
                                            }}
                                            variant="contained"
                                            {...bindTrigger(popupState)}
                                          >
                                            عملیات
                                          </Button> */}
                                          <Menu {...bindMenu(popupState)}>
                                            <MenuItem
                                              onClick={() =>
                                                this.handleRemove(item)
                                              }
                                            >
                                              حذف
                                            </MenuItem>
                                            <MenuItem
                                              onClick={() =>
                                                this.handleUpdate(item)
                                              }
                                            >
                                              ویرایش
                                            </MenuItem>
                                            <Link to={`/stage/${item?.id}`}>
                                              <MenuItem
                                                onClick={() =>
                                                  this.handleUpdate(item)
                                                }
                                              >
                                                رفتن به مراحل
                                              </MenuItem>
                                            </Link>
                                            <Link to={`/deals/${item?.id}`}>
                                              <MenuItem
                                                onClick={() =>
                                                  this.handleUpdate(item)
                                                }
                                              >
                                                نمایش معاملات
                                              </MenuItem>
                                            </Link>
                                          </Menu>
                                        </>
                                      )}
                                    </PopupState>
                                  </TableCell>
                                </TableRow>
                              </>
                            );
                          }
                        )}
                      </TableBody>
                    </Table>
                    <Pagination
                      count={
                        dealsModelsList?.pages ? dealsModelsList?.pages : 1
                      }
                      page={page}
                      total={dealsModelsList?.total}
                      pageNumber={dealsModelsList?.page_number}
                      onChangePage={this.handleChangePage}
                      rowsCountList={rowsCountList}
                      countValue={count}
                      onChangeCount={(value: any) => this.handleCount(value)}
                    />
                  </div>
                </>
                <CustomModal
                  myStyle="one-field-modal"
                  openModal={openAddModal}
                  onClose={() => this.setState({ openAddModal: !openAddModal })}
                >
                  <>
                    <div className="custom-modal-main-title mb-2">
                      <h1 className="custom-modal-title">افزودن معامله</h1>
                      <Cancel
                        myStyle="ps-2 cursor-pointer"
                        color="#000000"
                        onClick={() =>
                          this.setState({
                            openAddModal: !openAddModal,
                            subject: "",
                          })
                        }
                      />
                    </div>

                    <div className="custom-modal-content">
                    <div className="custom-modal-row">
                      <Input
                        myStyle="w-100"
                        title="عنوان معامله "
                        value={subject}
                        onChange={(e: any) =>
                          this.setState({ subject: e.target.value })
                        }
                        emptyState={() => this.setState({ subject: "" })}
                        error={
                          errorsList.filter(
                            (name: { path: string }) => name.path === "subject"
                          )?.[0]?.errors?.[0]
                        }
                      />
                    </div>
                    <div className="custom-modal-confirm">
                      <MyButton
                        myStyle="bg-green"
                        title="اعمال"
                        loading={(this.state as any).isCreating}
                        onClick={() => this.handleNewTransaction()}
                      />
                    </div>
                  </div>
                  </>
                </CustomModal>
                <CustomModal
                  myStyle="one-field-modal"
                  openModal={openEditModal}
                  onClose={() =>
                    this.setState({ openEditModal: !openEditModal })
                  }
                >
                  <>
                    <div className="custom-modal-main-title mb-2">
                      <h1 className="custom-modal-title">ویرایش معامله</h1>
                      <Cancel
                        myStyle="ps-2 cursor-pointer"
                        color="#000000"
                        onClick={() =>
                          this.setState({ openEditModal: !openEditModal })
                        }
                      />
                    </div>

                    <div className="custom-modal-content">
                    <div className="custom-modal-row">
                      <Input
                        myStyle=" w-100"
                        title="عنوان معامله "
                        value={subject}
                        onChange={(e: any) =>
                          this.setState({ subject: e.target.value })
                        }
                        emptyState={() => this.setState({ subject: "" })}
                        error={
                          errorsList.filter(
                            (name: { path: string }) => name.path === "subject"
                          )?.[0]?.errors?.[0]
                        }
                      />
                    </div>
                    <div className="custom-modal-confirm">
                      <MyButton
                        myStyle="bg-green"
                        title="اعمال"
                        loading={(this.state as any).isUpdating}
                        onClick={() => this.sendUpdate()}
                      />
                    </div>
                  </div>
                  </>
                </CustomModal>
                <CustomModal
                  myStyle="delete-modal"
                  openModal={openConfirmModal}
                  onClose={() =>
                    this.setState({ openConfirmModal: !openConfirmModal })
                  }
                >
                  <>
                    <div className="custom-modal-main-title mb-2">
                      <h1 className="custom-modal-title">حذف</h1>
                      <Cancel
                        myStyle="ps-2 cursor-pointer"
                        color="#000000"
                        onClick={() =>
                          this.setState({ openConfirmModal: !openConfirmModal })
                        }
                      />
                    </div>

                    <div className="custom-modal-content">
                    <div className="custom-modal-row mb-37">
                      آیا از حذف معامله با نام {selectedItem?.subject} اطمینان
                      دارید؟
                    </div>
                    <div className="custom-modal-confirm">
                      <MyButton
                        myStyle="bg-green"
                        title="اعمال"
                        loading={(this.state as any).isDeleting}
                        onClick={() => this.confirmDelete()}
                      />
                      <MyButton
                        myStyle="bg-green"
                        title="انصراف"
                        onClick={() =>
                          this.setState({
                            selectedItem: null,
                            openConfirmModal: false,
                          })
                        }
                      />
                    </div>
                  </div>
                  </>
                </CustomModal>
              </>
            )}
          </div>
        </Layout>
      </>
    );
  }
}
export default DealsModel;
